import { jsx as _jsx } from "react/jsx-runtime";
export const PanelGroup = (props) => _jsx("div", { className: "header", children: props.name });
